<template>
  <div class="corporate-premium corporate-premium-container mt-36 mb-64 sm:mt-42 sm:mb-42">
    <div class="md:m-auto relative">
      <img class="corporate-premium-sprite" src="@/images/bh-benefits/yellow-sprite.svg" />
      <div class="phone-box md:flex md:flex-row">
        <img src="@/images/bh-benefits/mobile-preview.svg" alt="Mobile preview of Sittercity premium" />
        <div class="premium-text-content desktop">
          <h2 class="text-h2">Sittercity Premium is included in your benefits</h2>
          <p class="text-lead mb-8 mt-16">Premium makes finding care easy:</p>
          <ul class="premium-section-list text-body">
            <li>Share what you need so the right sitter finds you</li>
            <li>Get responses in as little as 2 hours after sign up</li>
            <li>Vet sitters with background checks, references, and reviews</li>
            <li>Hire with confidence by messaging and interviewing</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="premium-text-content mobile">
      <h2 class="text-h2 m-16">Sittercity Premium is included in your benefits</h2>
      <p class="text-lead m-16">Premium makes finding care easy:</p>
      <ul class="premium-section-list text-body m-16 mb-15">
        <li>Share what you need so the right sitter finds you</li>
        <li>Get responses in as little as 2 hours after sign up</li>
        <li>Vet sitters with background checks, references, and reviews</li>
        <li>Hire with confidence by messaging and interviewing</li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'PremiumSection',
};
</script>
